import React, { Fragment, useEffect } from "react";
import "./WhyJoinUs.css";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";

function OurValues() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  };
  //
  $.fn.dataImg = function (options) {
    var settings = $.extend(
      {
        sml: 400,

        med: 800,

        lrg: 1000,

        resize: false,
      },
      options,
    );

    var elements = $(this);

    function getSrc(element) {
      var screen = $(window).width();

      if (screen > settings.med) {
        return element.data("lrg");
      } else if (screen <= settings.med && screen > settings.sml) {
        return element.data("med");
      }

      return element.data("sml");
    }

    function breakpoints() {
      elements.each(function () {
        var e = $(this);

        var src = getSrc(e);

        if (src != undefined) {
          if (e.is("img")) {
            e.attr("src", src);
          } else {
            e.css("background-image", "url(" + src + ")");
          }
        }
      });
    }
    breakpoints();

    if (settings.resize === true) {
      $(window).resize(function () {
        breakpoints();
      });
    }
  };

  var plannerSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  //
  // $(document).ready(function () {
  // 	$(".header-mobile-menu").click(function () {
  // 		$(".nav-wrapper").toggleClass("show-menu");
  // 	});
  // });
  $(document).ready(function () {
    // $(".header-mobile-menu").click(function () {
    // 	$(".nav-wrapper").toggleClass("show-menu");
    // });

    setTimeout(function () {
      $(".academy2").css("display", "none");
      $(".academy3").css("display", "none");
      $(".academy4").css("display", "none");
      $(".academy5").css("display", "none");
      $(".academy6").css("display", "none");
      $(".academy7").css("display", "none");
      $(".academy8").css("display", "none");
      $(".academy9").css("display", "none");
    }, 1000);

    $(".academybtncntr li").click(function () {
      $(".academybtncntr li").removeClass("active");
      $(this).addClass("active");

      if ($("#academy1").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy1").css("display", "block");
      }
      if ($("#academy2").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy2").css("display", "block");
      }
      if ($("#academy3").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy3").css("display", "block");
      }
      if ($("#academy4").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy4").css("display", "block");
      }
      if ($("#academy5").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy5").css("display", "block");
      }
      if ($("#academy6").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy6").css("display", "block");
      }
      if ($("#academy7").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy7").css("display", "block");
      }
      if ($("#academy8").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy8").css("display", "block");
      }
      if ($("#academy9").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy9").css("display", "block");
      }
    });
  });

  $(document).ready(function () {
    $(".facilities-view1").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      // //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view2").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view3").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view4").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view5").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view6").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view7").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view8").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view9").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  });

  return (
    <>
      <div className="main-container full_width why-join-us">
        <section className="section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg  wju-section-1  my-0 py-0 section-container">
          <div className="container">
            <div className="row d-flex">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item d-none">
                      <a href="/work-at-jio-institute">Work at Jio Institute</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Our Values
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>
        <section className="d-none section-common-space">
          <div className="container">
            <nav
              id="navbar-example2"
              className="navbar navbar-light bg-light px-3"
            >
              <ul className="nav nav-pills">
                <li className="nav-item">
                  <a className="nav-link" href="#scrollspyHeading11">
                    First
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#scrollspyHeading22">
                    Second
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </section>
        

          <section className="section-common-space bg-value overflow-hidden section-bg-red text-white wju-section-4 m-0 p-0 section-container">
            <div className="container">
              <div className={`row align-items-lg-center my-5 sec-4`}>
                <div className="col-12 col-lg">
                  <h3
                    className="h3-03 font-black text-lg-left text-center"
                    data-aos="fade-down"
                  >
                    Our Values
                  </h3>
                  <div className="d-lg-none mt-lg-0 mt-5">
                    <div className="rounded-circle masthead-rounded-circle-mob overflow-hidden">
                      <img
                        src="assets/images/career/our-values-side-img.jpg"
                        alt="about"
                        className="w-100"
                        width=""
                        height=""
                      />
                    </div>
                  </div>
                  <div className="row mb-5 mt-5">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={500}
                    >
                      <h5 className="h5-05 font-bold">Inclusiveness</h5>
                      <div className="body-02">
                        We foster an inclusive and caring environment that
                        embraces diverse backgrounds, identities and
                        perspectives. We treat all people with respect and
                        dignity. We listen to and encourage each other’s input
                        and opinion.
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={1000}
                    >
                      <h5 className="h5-05 font-bold">Freedom of Inquiry</h5>
                      <div className="body-02">
                        We provide an environment where bright, curious and
                        critical minds work together to advance new ideas and
                        technologies. We collaborate to explore, persevere and
                        ultimately resolve challenges. All research upholds the
                        highest standards of academic rigour.
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={1500}
                    >
                      <h5 className="h5-05 font-bold">Integrity</h5>
                      <div className="body-02">
                        We take accountability and responsibility for our
                        actions, decisions and behaviours. We are honest and do
                        the right thing in order to preserve both our personal
                        and the Institute’s reputations. We work together in a
                        collaborative and collegiate manner.
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={2000}
                    >
                      <h5 className="h5-05 font-bold">Growth Mindset</h5>
                      <div className="body-02">
                        We possess a love of learning and continually strive to
                        develop and improve ourselves and support others to do
                        the same. We are resilient and accept challenges and
                        failures as opportunities to grow.
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={2500}
                    >
                      <h5 className="h5-05 font-bold">Excellence</h5>
                      <div className="body-02">
                        We have a mind-set of giving our best, seeking new and
                        better ways to approach challenges, utilising a digital
                        first approach and continually work to improve
                        ourselves. We hold ourselves and our colleagues
                        accountable to this value
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={3000}
                    >
                      <h5 className="h5-05 font-bold">Courage</h5>
                      <div className="body-02">
                        We are resilient, patient and tenacious. We embrace new
                        (and old) challenges with passion and conviction. We
                        stand up for what is right
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={2500}
                    >
                      <h5 className="h5-05 font-bold">One Team</h5>
                      <div className="body-02">
                        We put the team ahead of our personal success and commit
                        to building its capability. We trust each other to
                        deliver on our respective obligations.
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={3000}
                    >
                      <h5 className="h5-05 font-bold">Ownership Mindset</h5>
                      <div className="body-02">
                        We maintain an ownership mind-set, viewing the company’s
                        success and reputation as paramount to our purpose. We
                        embrace accountability to drive accomplishment and
                        uphold the highest standards for safety and the
                        environment. We hold ourselves and our colleagues
                        accountable to this value.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-5 col-xl-auto d-lg-block d-none align-self-md-start">
                  <div className="rounded-circle masthead-rounded-circle overflow-hidden">
                    <img
                      src="assets/images/career/our-values-side-img.jpg"
                      width=""
                      height=""
                      alt="about"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
      </div>
    </>
  );
}

export default OurValues;
